/* eslint-disable no-empty-pattern */
import React, { useContext, useEffect, useState, Suspense } from "react"
import { Link } from "gatsby"
import { closeMobileModalOnClick } from "../../util/util"
import PrimaryArrow from "../../assets/img/arrow_right_primary.inline.svg"

import BusinessKuda from "../../assets/img/kudabusiness-logo.inline.svg"
import KudaLogo from "../../assets/img/kudabank-logo.inline.svg"
import { StateContext } from "../../contextApi"
import { useLocation } from "@reach/router"
import MobileSelectedOptions from "./mobileSelectedOptions"
import { K4bHeaderButton } from "../body/pages/general/K4bCtaHeaderButton"
const MobileHeader = (props) => {
  const location = useLocation()
  const [locationState, setLocation] = useState("")
  const [isBusiness, setIsBusiness] = useState(false)
  const [menuOption, setShowMenuOption] = useState(null)
  const [show, setShow] = useState(false)
  const [showGeneral, setShowGeneral] = useState(false)
  const [textColor, setTextColor] = useState("color-primary")
  const [selectedItem, setSelectedItem] = useState("Global")

  const countryPathname = () => {
    const pathName = location.pathname
    setLocation(pathName)
  }
  const toggleMenu = (pathName) => {
    if (locationState === pathName) {
      closeMobileModal()
    } else {
      closeMobileModal()
    }
  }

  useEffect(() => {
    setSelectedItem(props.selectedCountry)
  }, [props.selectedCountry])


  const [{ mobile }, dispatch] = useContext(StateContext)

  const handleToggle = () => {
    dispatch({
      newMobile: false,
      type: "CHANGE_MOBILE",
    })
  }

  const closeMobileModal = () => {
    dispatch({
      newMobile: false,
      type: "CHANGE_MOBILE",
    })
  }

  useEffect(() => {
    const pathName = location.pathname
    countryPathname()
    if (locationState.includes("/en-gb")) {
      setLocation(pathName)
      setShow(true)
    } else if (
      locationState.includes("/") ||
      locationState.includes("/press") ||
      locationState.includes("/faqs") ||
      locationState.includes("/contact")
    ) {
      setLocation(pathName)
      setShowGeneral(true)
    }
  }, [locationState])

  useEffect(() => {
    if (location?.pathname.includes("/en-ng/business") || location?.pathname.includes('/joinkudabusiness')) {
      setIsBusiness(true)
      setTextColor("color-black")
    } else {
      setTextColor("color-primary")
      setIsBusiness(false)
    }
  }, [location?.pathname])

  useEffect(() => {
    countryPathname()
    if (locationState.includes("/en-ng")) {
      setShowGeneral(false)
    }
  }, [locationState])

  useEffect(() => {
    if (mobile) {
      document.body.classList.add("overflow-hidden")
    } else {
      document.body.classList.remove("overflow-hidden")
    }
    closeMobileModalOnClick(closeMobileModal)
  }, [mobile])

  useEffect(() => {
    document.body.classList.remove("overflow-hidden")
  }, [])


  const logoRoute = () => {
    let selectedRoute = "/"
    switch (selectedItem) {
      case "Nigeria":
        selectedRoute = "/en-ng/"
        break;
      case "Global":
        selectedRoute = "/"
        break;
      default:
        selectedRoute = "/en-gb/"
        break;
    }
    return isBusiness ? "/en-ng/business/" : selectedRoute

  }



  const renderLogo = () => {
    let value = <></>
    if (menuOption) {
      value = <div className="flex flex-row align-center cursor-pointer"
        onClick={() => setShowMenuOption(null)}>
        <span
          className="mr-2"
          dangerouslySetInnerHTML={{
            __html:
              '<svg width="5" height="10" viewBox="0 0 5 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.97399 9.79687L0.121736 5.33966C-0.0405785 5.15204 -0.0405785 4.84891 0.121736 4.6608L3.97399 0.203586C4.2083 -0.0678621 4.58953 -0.0678621 4.82426 0.203586C5.05858 0.475035 5.05858 0.91559 4.82426 1.18704L1.81142 4.67351C1.64916 4.86128 1.64917 5.13965 1.81146 5.3274L4.82426 8.81293C5.05858 9.08487 5.05858 9.52542 4.82426 9.79687C4.58953 10.0683 4.2083 10.0683 3.97399 9.79687Z" fill="#40196D"/></svg>',
          }}
        ></span>
        <span className="color-primary text-sm">Back</span>
      </div>
    } else {
      value = <Link exact="true" to={logoRoute()} aria-label="Kuda logo" className="kuda-brand" onClick={closeMobileModal} >
        {isBusiness ? <BusinessKuda /> : <KudaLogo />}
      </Link>
    }
    return value

  }
  return (
    <div className="mobile-container">
      <div className="kuda-menu--wrap flex align-center">
        <div className="kuda-footer--nav flex flex-column">
          <div className="kuda-mobile--brand">
            {renderLogo()}
            <span
              className="closeMenu animated fadeIn cursor-pointer"
              onClick={closeMobileModal}
              dangerouslySetInnerHTML={{
                __html:
                  '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="1.61414" y="0.500275" width="21" height="2" rx="1" transform="rotate(45 1.61414 0.500275)" fill="#40196D"/><rect x="0.614136" y="15.5003" width="21" height="2" rx="1" transform="rotate(-45 0.614136 15.5003)" fill="#40196D"/></svg>',
              }}
            ></span>
          </div>
          <Suspense>

            <div className={`kuda-mobile--navWrap ${menuOption ? "show-options" : ""}`}>
              {
                !menuOption ?
                  <>
                    <div className="kuda-menu--actions flex">

                      <>
                        {isBusiness ? (

                          <K4bHeaderButton isMobile={true} />
                        ) : (
                          <>
                            {
                              locationState === '/joinKuda/' ?
                                <button onClick={() => toggleMenu()} className={`kuda-mobile--action kuda-cta kuda-cta-md mr-3 kuda_web`}>Join Kuda
                                </button> :
                                <Link to="/joinKuda/" className={`kuda-mobile--action kuda-cta kuda-cta-md mr-3 kuda_web`}>Join Kuda
                                </Link>
                            }
                          </>
                        )}
                      </>
                      <a
                        target="_blank"
                        href={
                          location?.pathname === "/en-ng/business/"
                            ? "https://business.kuda.com/login"
                            : "https://app.kuda.com"
                        }
                        className="kuda-mobile--action kuda-cta kuda-cta-md kuda-cta-v2 cta_button"
                      >
                        Sign In
                      </a>
                    </div>
                    <div className="flex flex-column">
                      {(selectedItem === "Nigeria" || selectedItem === "Global") &&

                        <div className="nav-menu-wrap flex flex-column">

                          <div className="kuda-mobile--menu-item" onClick={() => setShowMenuOption("personal-ng")}>
                            <p className={`footer-header text-bold  ${textColor}`}>
                              Personal
                            </p>
                            <PrimaryArrow />
                          </div>
                          <div className="kuda-mobile--menu-item" onClick={() => setShowMenuOption("business-ng")}>
                            <p className={`footer-header text-bold  ${textColor}`}>
                              Business
                            </p>
                            <PrimaryArrow />
                          </div>
                          <div className="kuda-mobile--menu-item" onClick={() => setShowMenuOption("company-ng")}>
                            <p className={`footer-header text-bold  ${textColor}`}>
                              Company
                            </p>
                            <PrimaryArrow />
                          </div>
                          <a className="kuda-mobile--menu-item"
                            href="https://developer.kuda.com/"
                            target="_blank"
                            rel="noopener noreferrer" onClick={() => toggleMenu()}>
                            <p className={`footer-header text-bold  ${textColor}`}>
                              Developers
                            </p>
                          </a>
                          <Link to="/contact/" className="kuda-mobile--menu-item"
                            onClick={() => toggleMenu("/contact/")}>
                            <p className={`footer-header text-bold  ${textColor}`}>
                              Contact Us
                            </p>
                          </Link>
                          <div className="kuda-mobile--menu-item" onClick={() => setShowMenuOption("help-ng")}>
                            <p className={`footer-header text-bold  ${textColor}`}>
                              Help
                            </p>
                            <PrimaryArrow />
                          </div>
                        </div>

                      }
                      {selectedItem === "United Kingdom" &&
                        <div className="nav-menu-wrap flex flex-column">
                          <div className="kuda-mobile--menu-item" onClick={() => setShowMenuOption("features-uk")}>
                            <p className={`footer-header text-bold  ${textColor}`}>
                              Features
                            </p>
                            <PrimaryArrow />
                          </div>
                          <div className="kuda-mobile--menu-item" onClick={() => setShowMenuOption("company-uk")}>
                            <p className={`footer-header text-bold  ${textColor}`}>
                              Company
                            </p>
                            <PrimaryArrow />
                          </div>
                          <a className="kuda-mobile--menu-item"
                            href="https://developer.kuda.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => toggleMenu()}>
                            <p className={`footer-header text-bold  ${textColor}`}>
                              Developers
                            </p>
                          </a>
                          <Link className="kuda-mobile--menu-item"
                            to="/en-gb/contact/">
                            <p className={`footer-header text-bold  ${textColor}`}>
                              Contact Us
                            </p>
                          </Link>
                          <div className="kuda-mobile--menu-item" onClick={() => setShowMenuOption("help-uk")}>
                            <p className={`footer-header text-bold  ${textColor}`}>
                              Help
                            </p>
                            <PrimaryArrow />
                          </div>
                        </div>
                      }
                    </div>

                  </> :
                  <div className="nav-menu-wrap flex flex-column">
                    <Suspense>
                      <MobileSelectedOptions selectedOption={menuOption} toggleMenu={toggleMenu} closeModal={toggleMenu} 
                      pathname={location?.pathname}
                      selectedCountry={selectedItem}/>

                    </Suspense>

                  </div>
              }
            </div>
          </Suspense>
        </div>
      </div>
    </div>
  )
}

export default MobileHeader

// class MobileHeader extends Component {
//   static contextType = StateContext

//   componentDidMount() {
//     document.body.classList.add("overflow-hidden")
//     closeMobileModalOnClick(this.closeMobileModal)
//   }

//   componentWillUnmount() {
//     document.body.classList.remove("overflow-hidden")
//   }

//   render() {
//     return (
//       <Location>
//         {({ location }) => (

//         )}
//       </Location>
//     )
//   }
// }
// export default MobileHeader
